import { Navigate } from 'react-router-dom';
import store from '@apply/adminStore';
import { hasPermission } from '@apply/ui';

export const RequireAuth = ({ children, additionalRequirement = true }) => {
    const { bfiUser } = store.getState();
    if (bfiUser.authenticated && additionalRequirement) {
        return children;
    } else {
        return <Navigate to={'/login'} />;
    }
};

export const RequireAdmin = ({ children }) => {
    const { bfiUser } = store.getState();
    return (
        <RequireAuth
            additionalRequirement={
                bfiUser.admin === true && bfiUser?.requiresESign !== true && bfiUser?.requiresAdminTermsESign !== true
            }
        >
            {children}
        </RequireAuth>
    );
};

export const RequireAdminEsign = ({ children }) => {
    const { bfiUser } = store.getState();
    return (
        <RequireAuth
            additionalRequirement={
                bfiUser.admin === true && (bfiUser?.requiresESign === true || bfiUser?.requiresAdminTermsESign == true)
            }
        >
            {children}
        </RequireAuth>
    );
};

export const RequireBroker = ({ children }) => {
    const { bfiUser } = store.getState();
    return (
        <RequireAuth additionalRequirement={bfiUser.isBroker === true && bfiUser?.areTermsAccepted === true}>
            {children}
        </RequireAuth>
    );
};

export const RequireBrokerEsign = ({ children }) => {
    const { bfiUser } = store.getState();
    return (
        <RequireAuth
            additionalRequirement={
                bfiUser.isBroker === true && bfiUser?.areTermsAccepted === true && bfiUser?.requiresESign === true
            }
        >
            {children}
        </RequireAuth>
    );
};

export const RequirePendingBroker = ({ children }) => {
    const { bfiUser } = store.getState();
    return (
        <RequireAuth additionalRequirement={bfiUser.isBroker === true && bfiUser?.areTermsAccepted !== true}>
            {children}
        </RequireAuth>
    );
};

export const RequirePermission = ({ children, permission }) => {
    return <RequireAuth additionalRequirement={hasPermission(permission)}>{children}</RequireAuth>;
};
